const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');

// Resets the device to an initial state, cancelling all in-flight commands, if any, from the POS software.
// @link https://docs.clover.com/docs/payment-reconciliation-and-recovery-rest-pay
class CloverDeviceCancelInFlightRequestRecord extends AbstractCloverRequestRecord {
    constructor() {
        // @link https://docs.clover.com/reference/cancel-1
        const url = '/connect/v1/device/cancel';
        super(
            'POST',
            url
        );
    }
}

module.exports = CloverDeviceCancelInFlightRequestRecord;
